import { BRAND } from "@/config/brand";

export function formatFcfa(amount: number, options?: { compact?: boolean }): string {
  if (options?.compact) {
    if (amount >= 1_000_000) {
      return `${(amount / 1_000_000).toLocaleString("fr-FR", { maximumFractionDigits: 1 })} M ${BRAND.currency}`;
    }
    if (amount >= 1_000) {
      return `${(amount / 1_000).toLocaleString("fr-FR", { maximumFractionDigits: 0 })} k ${BRAND.currency}`;
    }
  }
  return `${amount.toLocaleString("fr-FR").replace(/\u202f/g, " ")} ${BRAND.currency}`;
}

export function formatDate(date: string | Date, withTime = false): string {
  const d = typeof date === "string" ? new Date(date) : date;
  if (Number.isNaN(d.getTime())) return "-";
  const base = d.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
  if (!withTime) return base;
  return `${base} · ${d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })}`;
}